import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { publicApi } from "@/lib/account";

export default function OfferBanner() {
  const [offer, setOffer] = useState(null);
  useEffect(() => { publicApi.get("/offers/active").then((r) => setOffer(r.data)).catch(() => {}); }, []);
  if (!offer) return null;
  const ends = new Date(offer.end).toLocaleDateString(undefined, { day: "numeric", month: "short" });
  return (
    <Link to="/plans" data-testid="offer-banner" className="block bg-gradient-to-r from-[#6B0F1A] via-[#8a1c2b] to-[#6B0F1A] border-b border-amber-500/30">
      <div className="max-w-7xl mx-auto px-5 py-2.5 flex items-center justify-center gap-3 text-sm text-amber-100 text-center">
        <Sparkles className="w-4 h-4 text-amber-300 shrink-0" />
        <span><b className="text-amber-300">{offer.title}:</b> {offer.text || `${offer.percent}% off all plans`} · ends {ends}</span>
        <span className="hidden sm:inline px-3 py-0.5 rounded-full bg-amber-400 text-[#08090C] font-semibold text-xs">{offer.percent}% OFF</span>
      </div>
    </Link>
  );
}
